"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLHeadElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLHeadElementImpl
};
